module.exports = __webpack_public_path__ + "static/images/home-pfe.428adc5358ae54e0d85167b7d3ad89af.svg";